"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFailCodes = exports.DefaultErrorCodes = void 0;
exports.createHttpSaga = createHttpSaga;
const effects_1 = require("redux-saga/effects");
const actions_1 = require("../actions/index.js");
const sonar_http_1 = require("@sonar-software/sonar-http");
const fiveMinutes = 5 * 60 * 1000;
function isOfAnyStatus(statusCode, expectedStatuses) {
    return expectedStatuses.filter((expectedStatus) => statusCode === expectedStatus).length > 0;
}
exports.DefaultErrorCodes = [
    sonar_http_1.ErrorOrFailStatusCode.BadGateway,
    sonar_http_1.ErrorOrFailStatusCode.Forbidden,
    sonar_http_1.ErrorOrFailStatusCode.NotAcceptable,
    sonar_http_1.ErrorOrFailStatusCode.NotFound,
    sonar_http_1.ErrorOrFailStatusCode.RequestTimeout,
    sonar_http_1.ErrorOrFailStatusCode.ServerError,
    sonar_http_1.ErrorOrFailStatusCode.UnprocessableEntity
];
exports.DefaultFailCodes = [
    sonar_http_1.ErrorOrFailStatusCode.BadRequest,
    sonar_http_1.ErrorOrFailStatusCode.Conflict,
    sonar_http_1.ErrorOrFailStatusCode.Locked,
    sonar_http_1.ErrorOrFailStatusCode.Unauthorized,
    sonar_http_1.ErrorOrFailStatusCode.ServiceUnavailable
];
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createHttpSaga(options) {
    const { allowUnauthorized, errorCodeActionCreators = [], failCodeActionCreators = [], preRequestActionCreators = [], requestHandler, statusCodeHandlers = [], successDataActionCreators = [], successCombinationActionCreators = [], successDataHandlers = [], successActionCreators = [] } = options;
    if (errorCodeActionCreators.length) {
        statusCodeHandlers.push({
            actionCreators: errorCodeActionCreators,
            statuses: exports.DefaultErrorCodes
        });
    }
    if (failCodeActionCreators.length) {
        statusCodeHandlers.push({
            actionCreators: failCodeActionCreators,
            statuses: exports.DefaultFailCodes
        });
    }
    const cache = options.cache ? {} : undefined;
    const cacheOptions = typeof options.cache === 'object' ?
        options.cache : { duration: fiveMinutes };
    function tryGetFromCache(requestData) {
        var _a;
        const key = (_a = JSON.stringify(requestData)) !== null && _a !== void 0 ? _a : 'undefined';
        if (!cache || !cache[key]) {
            return undefined;
        }
        const entry = cache[key];
        if (Date.now() - cacheOptions.duration > entry.time) {
            delete cache[key];
            return undefined;
        }
        return entry.response;
    }
    function setCache(requestData, response) {
        var _a;
        if (!cache) {
            return;
        }
        const key = (_a = JSON.stringify(requestData)) !== null && _a !== void 0 ? _a : 'undefined';
        cache[key] = {
            response,
            time: Date.now()
        };
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function* getApi(action) {
        try {
            const requestData = action.data;
            for (let i = 0; i < preRequestActionCreators.length; i += 1) {
                yield (0, effects_1.put)(preRequestActionCreators[i](requestData));
            }
            let result;
            const cacheResult = tryGetFromCache(requestData);
            if (cacheResult) {
                result = cacheResult;
            }
            else if (requestData) {
                result = yield (0, effects_1.call)(requestHandler, requestData);
            }
            else {
                result = yield (0, effects_1.call)(requestHandler);
            }
            const { status } = result;
            if (status === sonar_http_1.SuccessStatusCode.Ok ||
                status === sonar_http_1.SuccessStatusCode.Accepted ||
                status === sonar_http_1.SuccessStatusCode.NoContent) {
                if (!cacheResult) {
                    setCache(requestData, result);
                }
                for (let i = 0; i < successDataHandlers.length; i += 1) {
                    successDataHandlers[i](result.data);
                }
                for (let i = 0; i < successActionCreators.length; i += 1) {
                    yield (0, effects_1.put)(successActionCreators[i]());
                }
                for (let i = 0; i < successDataActionCreators.length; i += 1) {
                    yield (0, effects_1.put)(successDataActionCreators[i](result.data));
                }
                if (requestData) {
                    for (let i = 0; i < successCombinationActionCreators.length; i += 1) {
                        yield (0, effects_1.put)(successCombinationActionCreators[i](requestData, result.data));
                    }
                }
            }
            if (status === sonar_http_1.ErrorOrFailStatusCode.Unauthorized && !allowUnauthorized) {
                yield (0, effects_1.put)((0, actions_1.unauthorizedError)(action));
            }
            if (status === sonar_http_1.ErrorOrFailStatusCode.ServiceUnavailable) {
                yield (0, effects_1.put)((0, actions_1.serviceUnavailableError)(action));
            }
            for (let i = 0; i < statusCodeHandlers.length; i += 1) {
                const handler = statusCodeHandlers[i];
                if (isOfAnyStatus(status, handler.statuses)) {
                    for (let x = 0; x < handler.actionCreators.length; x += 1) {
                        yield (0, effects_1.put)(handler.actionCreators[x]({ statusCode: status }));
                    }
                }
            }
        }
        catch (e) {
            yield (0, effects_1.put)((0, actions_1.error)(e.message));
        }
    };
}
//# sourceMappingURL=createHttpSaga.js.map